<template>
  <q-layout view="hHh lpR fFf" class="bg-grey-1">
    <!-- Header Superior con Texto Claramente Visible -->
    <q-header elevated class="bg-primary text-white">
      <q-toolbar class="q-py-xs">
        <div class="flex items-center q-gutter-sm">
          <q-avatar square size="36px">
            <img :src="logoPath" alt="Logo" />
          </q-avatar>
          <div class="text-subtitle1 text-weight-bold text-white gt-xs">
            Corporación Aveo EIRL.
          </div>
        </div>

        <q-space />

        <!-- Botones de Acción Superiores con Texto e Íconos Visibles -->
        <div class="flex items-center q-gutter-xs">
          <q-btn
            flat
            color="white"
            icon="person_add"
            label="Registrarse"
            no-caps
            class="text-weight-medium"
            @click="registro"
          />
          <q-btn
            flat
            color="white"
            icon="vpn_key"
            label="Ingresar"
            no-caps
            class="text-weight-bold"
            @click="showLoginDialog"
          />
          <q-btn
            flat
            color="white"
            icon="menu_book"
            label="Documentación"
            no-caps
            class="gt-xs text-weight-medium"
            @click="documentation"
          />
          <q-btn
            flat
            color="white"
            icon="phone"
            label="958863622"
            no-caps
            class="gt-sm text-weight-medium"
          />
          <q-btn
            flat
            color="white"
            icon="email"
            label="jcalderon@aveoperu.com"
            no-caps
            class="gt-md text-weight-medium"
          />
        </div>

        <q-btn flat round dense icon="menu" class="lt-sm" @click="drawer = !drawer" />
      </q-toolbar>
    </q-header>

    <!-- Drawer para Móvil -->
    <q-drawer v-model="drawer" side="left" overlay bordered class="bg-white">
      <q-list padding>
        <q-item clickable v-ripple @click="registro">
          <q-item-section avatar><q-icon name="person_add" color="primary" /></q-item-section>
          <q-item-section class="text-weight-medium">Registrarse</q-item-section>
        </q-item>
        <q-item clickable v-ripple @click="showLoginDialog">
          <q-item-section avatar><q-icon name="vpn_key" color="primary" /></q-item-section>
          <q-item-section class="text-weight-bold">Ingresar</q-item-section>
        </q-item>
        <q-item clickable v-ripple @click="documentation">
          <q-item-section avatar><q-icon name="menu_book" color="primary" /></q-item-section>
          <q-item-section class="text-weight-medium">Documentación</q-item-section>
        </q-item>
      </q-list>
    </q-drawer>

    <!-- Modal de Iniciar Sesión Elegante y Funcional -->
    <q-dialog v-model="loginDialog" persistent transition-show="slide-up" transition-hide="slide-down">
      <q-card style="width: 450px; max-width: 95vw;" class="rounded-borders shadow-8">
        <q-card-section class="bg-primary text-white row items-center justify-between q-py-md">
          <div class="text-h6 text-weight-bold row items-center">
            <q-icon name="account_circle" class="q-mr-sm" size="sm" />
            Iniciar Sesión
          </div>
          <q-btn icon="close" flat round dense v-close-popup @click="closeLoginDialog" />
        </q-card-section>

        <q-card-section class="q-pa-lg">
          <q-form @submit.prevent="ingresar" class="q-gutter-y-md">
            <q-input
              v-model="alias"
              label="Usuario o Email *"
              outlined
              dense
              stack-label
              autofocus
              :rules="[val => !!val || 'Ingrese usuario o email']"
            >
              <template v-slot:prepend>
                <q-icon name="person" color="primary" />
              </template>
            </q-input>

            <q-input
              v-model="password"
              type="password"
              label="Contraseña *"
              outlined
              dense
              stack-label
              :rules="[val => !!val || 'Ingrese contraseña']"
            >
              <template v-slot:prepend>
                <q-icon name="lock" color="primary" />
              </template>
            </q-input>

            <div class="row justify-end q-gutter-sm q-pt-md">
              <q-btn label="Cancelar" flat color="grey-7" v-close-popup @click="closeLoginDialog" no-caps />
              <q-btn
                type="submit"
                label="Ingresar al Sistema"
                color="primary"
                unelevated
                no-caps
                :loading="loading"
                class="text-weight-bold q-px-md"
              />
            </div>
          </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>

    <!-- Cuerpo de la Página de Inicio -->
    <q-page-container>
      <q-page class="q-pa-md">
        <!-- Slider Carrusel de Imágenes -->
        <MainCarrusel />

        <div class="column items-center q-my-md text-center">
          <div class="text-h4 text-weight-bold text-primary">PLANES DISPONIBLES</div>
          <div class="text-subtitle1 text-grey-7 q-mt-xs">Los Precios Incluyen Impuesto General a las Ventas (I.G.V.)</div>
          <q-chip color="warning" text-color="white" class="q-mt-sm text-weight-medium shadow-1">
            Al registrarse automáticamente obtiene un plan gratuito de prueba (hasta 100 comprobantes)
          </q-chip>
        </div>

        <div class="row justify-center">
          <div class="col-12 col-md-10">
            <plan :items="Planes" />
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import axios from "axios";
import MainCarrusel from "@/components/Header/MainCarrusel.vue";
import plan from "@/components/Planes/Planes.vue";

export default {
  name: "InicioPage",
  components: { MainCarrusel, plan },
  data() {
    return {
      loginDialog: false,
      drawer: false,
      logoPath: require("@/assets/logo.svg"),
      loading: false,
      alias: "",
      password: "",
      Planes: [],
    };
  },
  mounted() {
    this.cargarplanes();
  },
  methods: {
    showLoginDialog() {
      this.loginDialog = true;
    },
    closeLoginDialog() {
      this.loginDialog = false;
    },
    registro() {
      this.$router.push("/registro");
    },
    documentation() {
      this.$router.push("/documentacion");
    },
    async cargarplanes() {
      let me = this;
      try {
        const response = await axios.get("ApiWeb/PlanActivos.php");
        if (response.data && response.data.data) {
          me.Planes = response.data.data;
        }
      } catch (error) {
        console.error("Error al cargar planes", error);
      }
    },
    ingresar() {
      if (!this.alias || !this.password) {
        this.notificar("Ingrese su usuario y contraseña", "warning");
        return;
      }
      this.loading = true;
      let me = this;
      axios.post("ApiWeb/UsuarioLogin.php", {
        login: this.alias,
        password: this.password,
      })
        .then((res) => {
          if (res.data && res.data.error === false) {
            window.localStorage.setItem("authenticated", res.data.token || "true");
            if (me.$store) {
              me.$store.commit("settipo", res.data.tipo || "admin");
              me.$store.state.usuario = me.alias;
            }
            me.notificar("¡Bienvenido al sistema!", "positive");
            me.closeLoginDialog();
            me.$router.push("/aveo/Dashboard");
          } else {
            me.notificar(res.data.mensaje || "Usuario o contraseña incorrectos", "negative");
          }
        })
        .catch((err) => {
          console.error(err);
          me.notificar("Error de conexión al autenticar", "negative");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    notificar(msg, color) {
      if (this.$q && this.$q.notify) {
        this.$q.notify({
          message: msg,
          color: color,
          position: "top-right",
          timeout: 3000
        });
      } else {
        alert(msg);
      }
    }
  },
};
</script>
